import React from 'react';
import { getClient } from '../../apollo';
import { Button, Descriptions, Divider, Drawer, Skeleton } from 'antd';
import { constructEmail, openEmailClient, sendEmail } from '../../utils/email';
import { getMobileApk } from '../../utils/mobile';
import { useGetPassengerQuery } from '../../graphql/datamodel.gen';
interface IProps {
  passengerId: string;
  volcanoServiceId?: string;
  visible: boolean;
  onClose: () => any;
}

const PassengerDetailDrawer: React.FC<IProps> = (props: IProps) => {
  const { loading, data } = useGetPassengerQuery({
    client: getClient(),
    variables: {
      id: props.passengerId,
    },
    fetchPolicy: 'network-only',
  });

  const passenger = data?.passenger;

  if (!props.passengerId) return null;

  if (loading) {
    return <Skeleton active={true} loading={true} />;
  }

  return (
    <Drawer
      title={`Pasajero: ${passenger.name}`}
      width={600}
      destroyOnClose={true}
      maskClosable={true}
      closable={true}
      visible={props.visible}
      onClose={props.onClose}
    >
      <Descriptions
        title={'Información general'}
        bordered={true}
        size={'default'}
        column={1}
      >
        <Descriptions.Item label={'ID'}>{passenger.id}</Descriptions.Item>
        <Descriptions.Item label={'Nombre'}>{passenger.name}</Descriptions.Item>
        <Descriptions.Item label={'Correo electrónico'}>
          {passenger.email}
        </Descriptions.Item>
        <Descriptions.Item label={'Teléfono'}>
          {passenger.phone}
        </Descriptions.Item>
      </Descriptions>
      <Divider />
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
        }}
      >
        <Button
          onClick={() => {
            if (props.volcanoServiceId) {
              sendEmail(
                constructEmail(props.volcanoServiceId, passenger.email),
              );
            } else {
              openEmailClient(passenger.email);
            }
          }}
        >
          Enviar email
        </Button>
        <Button
          style={{ marginLeft: '20px' }}
          onClick={async () => {
            const url = await getMobileApk('passenger');
            const mailTo = `mailto:${
              passenger.email
            }?subject=Aplicación móvil&body=${encodeURIComponent(
              url as string,
            )}`;
            sendEmail(mailTo);
          }}
        >
          Enviar aplicación móvil
        </Button>
      </div>
    </Drawer>
  );
};

export default PassengerDetailDrawer;
